import React, { Component } from "react"
import { Route } from "react-router-dom"
import "./App.css"
import diaries from "./diaries.json"

import Header from "./components/Header.js"
import Welcome from "./pages/Welcome.js"
import Diaries from "./pages/Diaries.js"

const nullDiaries = [{ title: " ", patternIndex: 0 }]

class App extends Component {
  constructor(props) {
    super(props)
    this.state = { current: 0, diaries: nullDiaries }
  }

  render() {
    return (
      <div className="App">
        <Header
          diaries={this.state.diaries}
          current={this.state.current}
          onEntryClick={index => {
            this.setState({ current: index })
          }}
        />
        <div className="Body">
          <div className="Column">
            <Route
              exact
              path="/"
              render={() => {
                if (this.state.diaries !== nullDiaries)
                  this.setState({ current: 0, diaries: nullDiaries })
                return <Welcome />
              }}
            />
            <Route
              path="/diaries"
              render={() => {
                if (this.state.diaries !== diaries) {
                  this.setState({ current: 0, diaries: diaries })
                }
                return <Diaries entry={diaries[this.state.current]} />
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js